import { ThemePalette, ProgressSpinnerMode } from '@angular/material';
import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss']
})
export class AnalyticsComponent implements OnInit {

  selected_from_date = null;
  selected_to_date = null;
  document_file = null;
  report_type = null;
  title: any;
  report_option = null;
  booth_codes = null;
  business_type_list = [];
  selected_business_type_list = [];
  by_product_group_list = [];
  by_product_dict = {};
  selected_product_group_id = null;
  selected_product_ids = []
  grn_numbers = null;
  purchase_company_list = [];
  selected_purchase_company_list = [];
  is_document_available: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';


  constructor(private global: GlobalService, private httpService: HttpService) {
    this.title = this.global._active_display_name;
    this.httpService.getBoothTypes().subscribe((data: any) => {
      console.log(data);
      this.business_type_list = data;
    }, (error) => {
      console.error(error);
    });
    this.httpService.serveInputStock().subscribe((data) => {
        console.log(data);
        this.by_product_group_list = data["by_product_group_list"];
        this.by_product_dict = data["by_product_dict"];
      },(error) => {
        console.error(error);
      }
    );
    this.httpService.servePurchaseCompany().subscribe((data: any) => {
        console.log(data);
        this.purchase_company_list = data;
      },(error) => {
        console.error(error);
      }
    );
  }

  changeEvent() {
    this.document_file = null;
  }

  reportTypeChanged() {
    this.report_option = null;
    this.selected_business_type_list = [];
    this.selected_product_ids = [];
    this.grn_numbers = null;
    this.selected_purchase_company_list = []
    this.booth_codes = null;
    this.selected_product_group_id = null;
  }

  reportOptionChanged() {
    this.selected_business_type_list = [];
    this.selected_product_ids = [];
    this.grn_numbers = null;
    this.selected_purchase_company_list = []
    this.booth_codes = null;
    this.selected_product_group_id = null;
  }

  getClicked() {
    if (this.selected_from_date == null || this.selected_to_date == null) {
      alert('Please select date');
      return false;
    }
    if (this.report_type == null) {
      alert('Please select report type');
      return false;
    }
    if (this.report_option == null) {
      alert('Please select report option');
      return false;
    }
    let data_dict = {
      "from_date": this.selected_from_date,
      "to_date": this.selected_to_date,
      "report_option": this.report_option,
      "type": this.report_type,
      'user_check_box_list': []
    }
    let booth_list = []
    if (this.booth_codes !== null) {
      booth_list = this.booth_codes.split(',');
    }

    let grn_number_list = []
    if (this.grn_numbers !== null) {
      grn_number_list = this.grn_numbers.split(',');
    }
    data_dict['booth_code'] = booth_list;
    data_dict['business_type_id'] = this.selected_business_type_list;
    data_dict['by_product_ids'] = this.selected_product_ids;
    data_dict['grn_number_id'] = grn_number_list;
    data_dict['purchase_company_id'] = this.selected_purchase_company_list;
    console.log(data_dict)
    this.is_document_available = false;
    this.httpService.serveByProductAnalystics(data_dict).subscribe((data) => {
      console.log(data);
      this.document_file = data
      this.is_document_available = true;
    }, (error) => {
      console.error(error);
      this.is_document_available = true;
    });

  }

  downloadClicked() {
    const linkSource = 'data:application/excel;base64,' + this.document_file['excel'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  ngOnInit() {
  }

}
